import React, { useState, useEffect, useRef } from "react";
import queryString from "query-string";
import { Form, Progress, Alert, Input, Row, Col, Container } from "reactstrap";
import { CSSTransition } from "react-transition-group";

import { useLocalization } from "../../containers/I18nProvider";
import { WithCaptcha } from '../../containers/captcha';

import logo from './img/logo.jpg'
import { checkDeviceIOS } from '../../utils'

const LoginForm = ({ api, location, TurnstileComponent, ...props }) => {
  const nodeRef = useRef(null);
  const { translate, changeDefaultLocale } = useLocalization();
  changeDefaultLocale('es');
  const [onLogin, setOnLogin] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [error, setError] = useState({
    open: false,
    message: "",
  });
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const parameters = queryString.parse(location.search);
  parameters.idp = 'dibox';

  useEffect(() => {
    setShowForm(true)
  }, []);

  const onSubmit = async (ev) => {
    ev.preventDefault();
    setOnLogin(true)
    setError({
      open: false,
      message: "",
    })

    api.userPassLogin(
      {
        username,
        password,
      },
      parameters
    )
      .then((response) => {
        setOnLogin(false)
        window.location = parameters.redirect_uri + "?" + queryString.stringify(response);
      })
      .catch((error) => {
        const _translate = translate(error.errorCode);

        let message = "USUARIO NAO ENCONTRADO.";

        if (_translate) {
          message = _translate;
        } else if (error.details) {
          message = error.details;
        }
        setOnLogin(false)
        setError({ open: true, message: message })
      });
  }

  return (
    <CSSTransition
      in={showForm}
      timeout={300}
      classNames="formshow"
      nodeRef={nodeRef}
      unmountOnExit
    >
      <div className="login-dibox-container" ref={nodeRef}>
        <img src={logo} alt="logo" className="logo-dibox rounded mx-auto d-block" />
        <h3>Autenticación para clientes Dibox</h3>
        <Form onSubmit={(event) => onSubmit(event)}>
          <Container fluid={true} className="dibox-form-container">
            <Row className="dibox-form-header">
              <h4>Inicio de sesión</h4>
            </Row>
            <Row className="dibox-form-body">
              <Col sm="12" xs="12" md="12" className="dibox-input">
                <label>Correo electrónico</label>
                <Input
                  className="user-input-dibox"
                  disabled={onLogin}
                  required={true}
                  tabIndex={1}
                  type="text"
                  autoCorrect="off"
                  autoCapitalize="none"
                  id="username"
                  onChange={e => setUsername(e.target.value)}
                />
              </Col>
              <Col sm="12" xs="12" md="12" className="dibox-input">
                <label>Contraseña</label>
                <Input
                  className="pass-input-dibox"
                  required={true}
                  disabled={onLogin}
                  tabIndex={1}
                  type="password"
                  autoCorrect="off"
                  autoCapitalize="none"
                  id="password"
                  onChange={e => setPassword(e.target.value)}
                />
              </Col>
            </Row>
            <Row className="dibox-form-footer">
              <Col sm="12" xs="12" md="12">
                <p className="dibox-register-link">
                  {
                    checkDeviceIOS() ? '' : <a href="https://clientes.dibox.com.ar/registro.php" target="_blank" rel="noopener noreferrer">Registrarse</a>
                  }
                </p>
              </Col>
              <Col sm="12" xs="12" md="12">
                <p className="dibox-recovery-pass-link">¿Olvido su contraseña?
                  <a href="https://clientes.dibox.com.ar/forgot.php" target="_blank" rel="noopener noreferrer"> Restablecer</a>
                </p>
              </Col>
              {!onLogin ? (
                <div style={{ float: 'right', flex: 'auto' }}>
                  <button
                    block={!parameters.failureRedirect}
                    tabIndex={1}
                    type="submit"
                    id="submmit"
                    className="enter-dibox"
                    disabled={!props.turnstileSuccess}
                  >
                    {translate("ButtonEnter")}
                  </button>
                </div>
              ) : (
                <Progress animated color="danger" value={100} />
              )}
              <div className="messages-container">
                <Alert
                  color="danger"
                  id="error-message"
                  isOpen={error.open}
                  toggle={() => setError({ open: false })}
                >
                  {error.message}
                </Alert>
              </div>
              <TurnstileComponent setTurnstileSuccess={props.setTurnstileSuccess} />
            </Row>
          </Container>
        </Form>
      </div>
    </CSSTransition>
  );
}

export default WithCaptcha(LoginForm, { useInsideForm: true, style: { marginTop: '1rem' } });
